module.exports = __webpack_public_path__ + "jtails-build/img/another_banner@2.2af8b51e.jpg";